export interface ComparisonReport {
  incorrectTypes: number;
  missingProperties: number;
  totalDiffCount: number;
  unequalValues: number;
}
